import { Control, Controller, FieldError, RegisterOptions } from 'react-hook-form';
import Select, { OnChangeValue, Options } from 'react-select';
import style from '../SelectFieldCommons/SelectField.module.scss';
import { SelectCustomStyles } from '../SelectFieldCommons/CustomStyles.ts';
import { getCommonTheme } from '../SelectFieldCommons/CommonTheme.ts';

type SelectFieldProps<T> = {
  name: string;
  placeholder?: string;
  options?: Options<T>;
  value?: T | null;
  onChange?: (selectedOption: T | null) => void;
  isDisabled?: boolean;
  isLoading?: boolean;
  defaultValue?: any;
  control?: Control<any>;
  error?: FieldError | undefined;
  rules?: Partial<RegisterOptions>;
};

const SelectField = <T extends OnChangeValue<any, any>>({
  name,
  placeholder,
  options,
  value,
  onChange,
  isDisabled,
  isLoading,
  defaultValue,
  control,
  rules,
}: SelectFieldProps<T>) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      rules={rules}
      render={({ field }) => (
        <Select
          {...field}
          name={name}
          classNames={{
            dropdownIndicator: () => {
              return style.custom_dropdown_indicator;
            },
          }}
          placeholder={placeholder}
          options={options}
          value={value}
          onChange={(selectedOption: any) => {
            field.onChange(selectedOption?.value);
            if (onChange) onChange(selectedOption?.value);
          }}
          isDisabled={isDisabled}
          isLoading={isLoading}
          styles={SelectCustomStyles}
          theme={getCommonTheme}
        />
      )}
    />
  );
};

export default SelectField;
